import React, { useState } from "react";

import PolicyForm from "../../../../PolicyPlans/Form";

import { useContext } from "../../Context";

export default function Create({ template, onCancel }) {
  const { dispatch, actions, state } = useContext();

  const onSave = (values, onError) => {
    actions.createPlan(
      dispatch,
      state.enterpriseId,
      values,
      () => {
        actions.load(dispatch, state.enterpriseId);
      },
      (errors) => {
        onError(errors);
      }
    );
  };

  const onCancelHandler = () => {
    onCancel();
  };

  return (
    <PolicyForm
      onSubmit={onSave}
      onCancel={onCancelHandler}
      typeView="policy"
      template={template}
    />
  );
}
